module.exports = __webpack_public_path__ + "img/Evans.8d438bde.png";